import { ReactNode } from "react";
import { User } from "../../types";
import { AppSidebar } from "./AppSidebar";
import { SidebarProvider, SidebarInset } from "../ui/sidebar";
import { Header } from "./Header";

interface AppLayoutProps {
  children: ReactNode;
  currentUser: User;
  onLogout: () => void;
  currentTheme: "light" | "dark" | "auto";
  onThemeChange: (theme: "light" | "dark" | "auto") => void;
  isTransitioning?: boolean;
}

export function AppLayout({
  children,
  currentUser,
  onLogout,
  currentTheme,
  onThemeChange,
  isTransitioning,
}: AppLayoutProps) {
  return (
    <SidebarProvider storageKey={`sidebar_state_${currentUser.id}`}>
      <div className="h-screen flex w-full bg-background overflow-hidden selection:bg-primary selection:text-primary-foreground">
        <AppSidebar currentUser={currentUser} onLogout={onLogout} />
        <SidebarInset className="flex-1 flex flex-col h-screen min-w-0">
          <Header
            currentUser={currentUser}
            currentTheme={currentTheme}
            onThemeChange={onThemeChange}
            isTransitioning={isTransitioning}
          />
          <main className="flex-1 overflow-y-auto overflow-x-hidden p-3 sm:p-6 md:p-8 bg-background bg-tech-grid">
            <div className="mx-auto max-w-7xl w-full">
              {children}
            </div>
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
